import { render, staticRenderFns } from "./setting-accountProperties.vue?vue&type=template&id=30206e2a&scoped=true&"
import script from "./setting-accountProperties.vue?vue&type=script&lang=js&"
export * from "./setting-accountProperties.vue?vue&type=script&lang=js&"
import style0 from "./setting-accountProperties.vue?vue&type=style&index=0&id=30206e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30206e2a",
  null
  
)

export default component.exports